import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

const QuestionSummary = (props) => {
    const { open, toggleOpen, fields } = props;
    return (
        <Dialog
            open={open}
            onClose={toggleOpen}
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle> Question Summary </DialogTitle>
            <DialogContent>
                {fields.map((field, idx) => (
                    <div key={idx}>
                        <p> <b> {`${idx + 1}.`} </b> {field.title} </p>
                        {field.type === 'opinion_scale' &&
                            <b> {`(Scale: ${getScale(field.properties.start_at_one, field.properties.steps)})`} </b>
                        }
                        {field.type === 'multiple_choice' &&
                            <ol style={{ fontWeight: 'bold' }}>
                                {field.properties.choices.map((option) => {
                                    return (
                                        <li key={option.id} style={{ margin: 2 }}> {`${option.label}`} </li>
                                    )
                                })}
                            </ol>
                        }
                        {field.type === 'yes_no' &&
                            <b> (Yes or No) </b>
                        }
                        {field.type === 'group' &&
                            <React.Fragment>
                                <h4 style={{ marginBottom: 0 }}> (Group) </h4>
                                {field.properties.fields &&
                                    <ol>
                                        {field.properties.fields.map((gField) => {
                                            return (
                                                <li type="a" key={gField.ref} style={{ margin: 2 }}>
                                                    <p style={{ fontSize: '1.1rem' }}>{` ${gField.title}`}</p>
                                                </li>
                                            )
                                        })}
                                    </ol>
                                }
                            </React.Fragment>
                        }
                        {field.type === 'long_text' &&
                            <b> (Long text) </b>
                        }
                        {field.type === 'short_text' && 
                            <b> (Short text) </b>
                        }
                    </div>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={toggleOpen} color="primary">
                    Close
                    </Button>
            </DialogActions>
        </Dialog>
    )
};

function getScale(start_at_one, steps) {
    let start = start_at_one ? 1 : 0;
    let limit = start_at_one ? steps : steps - 1;
    let scale = `${start} - ${limit}`
    return scale;
}

export default QuestionSummary;